<main>
  <loading-overlay [isLoading]="isLoading() > 0" />

  @if (view(); as v) {
    <nav class="crumbs">
      <i class="pi pi-folder"></i>
      <span>{{ 'Finance' | translateWF: 'Finance' }}</span>
      <i class="pi pi-angle-right"></i>
      <span>{{ 'Ledger' | translateWF: 'Ledger' }}</span>
      <i class="pi pi-angle-right"></i>
      <a class="crumb-link" (click)="back()">{{ 'COA_Title' | translateWF: 'Chart of Accounts' }}</a>
      <i class="pi pi-angle-right"></i>
      <span class="current">{{ accountName() }}</span>
    </nav>

    <header>
      <div>
        <h1>{{ accountName() }}</h1>
        <p class="subtitle">
          {{ 'COA_Account' | translateWF: 'Account' }} {{ v.accountNumber }} · {{ 'COA_SubledgerBy' | translateWF: 'subledger by' }} {{ partyNoun() }} ·
          {{ 'COA_ComputedFrom' | translateWF: 'balances computed from journal postings' }}
        </p>
      </div>
      <div class="buttons">
        <p-selectbutton
          [options]="scopeOptions"
          [ngModel]="includeSettled()"
          (ngModelChange)="onScopeChange($event)"
          optionLabel="label"
          optionValue="value"
          [allowEmpty]="false"
        />
        <p-select
          [options]="monthOptions"
          [ngModel]="period()"
          (ngModelChange)="onPeriodChange($event)"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="w-40"
          [pTooltip]="'COA_PeriodMonth' | translateWF: 'Fiscal month (period-to-date)'"
        />
        <p-select [options]="yearOptions" [ngModel]="year()" (ngModelChange)="onYearChange($event)" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-28" />
        <p-button [label]="'Export' | translateWF: 'Export'" icon="pi pi-download" variant="outlined" (click)="export()" />
      </div>
    </header>

    <div class="content">
      <!-- Reconciliation summary -->
      <div class="card summary-card">
        <div>
          <span class="label">{{ 'COA_ReconciliationAccount' | translateWF: 'Reconciliation account' }}</span>
          <div class="account-line">{{ v.accountNumber }} — {{ accountName() }}</div>
          <span class="meta">{{ v.parties.length }} {{ partyNounPlural() }} · {{ v.asOfDate | date: 'dd/MM/yyyy' }}</span>
        </div>
        <div class="balance-block">
          <span class="label">{{ 'COA_AccountBalance' | translateWF: 'Account balance' }}</span>
          <strong class="balance">{{ v.accountBalance | number: '1.2-2' }} {{ v.currency }}</strong>
        </div>
      </div>

      <!-- Party table -->
      <div class="card table-card">
        <p-table [value]="v.parties" [rowHover]="true" styleClass="p-datatable-sm">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'COA_SubledgerParty' | translateWF: 'Subledger party' }}</th>
              <th style="width: 12rem">{{ 'COA_Activity' | translateWF: 'Activity' }}</th>
              <th class="text-right" style="width: 16rem">{{ 'COA_Balance' | translateWF: 'Balance' }} · {{ v.currency }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr class="cursor-pointer" (click)="openParty(row.partyReference)">
              <td>
                <div class="party-name">{{ row.name || row.partyReference }}</div>
                @if (row.code) {
                  <div class="party-code">{{ row.code }}</div>
                }
              </td>
              <td class="text-muted">
                @if (row.balance === 0) {
                  {{ 'COA_Settled' | translateWF: 'Settled' }}
                } @else {
                  {{ row.openCount }} {{ 'COA_Open' | translateWF: 'open' }}
                }
              </td>
              <td class="text-right tabular-nums">
                {{ row.balance | number: '1.2-2' }} {{ v.currency }}
                <i class="pi pi-angle-right open-chevron"></i>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr class="total-row" [class.ties]="v.tiesOut">
              <td>
                <i class="pi" [ngClass]="v.tiesOut ? 'pi-check-circle' : 'pi-exclamation-circle'"></i>
                {{ 'COA_Total' | translateWF: 'Total' }} ·
                {{ v.tiesOut ? ('COA_TiesTo' | translateWF: 'ties to') : ('COA_DoesNotTie' | translateWF: 'does not tie to') }}
                {{ v.accountNumber }}
              </td>
              <td></td>
              <td class="text-right tabular-nums font-semibold">{{ v.partiesTotal | number: '1.2-2' }} {{ v.currency }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="empty-cell">
                <i class="pi pi-inbox"></i>
                @if (includeSettled()) {
                  <p>{{ 'COA_NoSubledgerAny' | translateWF: 'No subledger parties on this account as of' }} {{ v.asOfDate | date: 'dd/MM/yyyy' }}.</p>
                } @else {
                  <p>{{ 'COA_NoSubledger' | translateWF: 'No open subledger items on this account as of' }} {{ v.asOfDate | date: 'dd/MM/yyyy' }}.</p>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  }
</main>
